import styled from 'styled-components';
const config = require('../data.json');

export default styled.div`
  background-color: #f0f0f0;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '400px')};
`;
